import { render, staticRenderFns } from "./SwitchBtn.vue?vue&type=template&id=157ce59e&scoped=true"
import script from "./SwitchBtn.vue?vue&type=script&lang=ts"
export * from "./SwitchBtn.vue?vue&type=script&lang=ts"
import style0 from "./SwitchBtn.vue?vue&type=style&index=0&id=157ce59e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ce59e",
  null
  
)

export default component.exports